import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { useMutation } from "react-query";
import { ReportingPayload } from "../../shared/interfaces/ReportingPayload";

export function useCreateReport(callbacks?: QueryCallbacks<Response | undefined>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    async (reportingPayload: ReportingPayload) => {
      return await apiContext.utp2FilesAPIs.postCreateReport(reportingPayload);
    },
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
